import { Grid, TextField, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  fetchChangeLegendData,
  selector as referenceLineStoreSelector,
} from "../../../store/ReferenceLineStore";
import useStyles from "../useStyles";

/**
 * PressManagementDialogFormRowコンポーネント.
 *
 * @param {object} info 線種情報
 * @return {object} コンポーネント
 */
function PressManagementDialogFormRow(props) {
  // 引数
  const {
    // 線種情報
    info,
  } = props;

  // スタイル
  const styles = useStyles();

  // Dispatch
  const dispatch = useDispatch();

  // Store情報
  const {
    // 凡例名称情報
    legendData,
  } = useSelector(referenceLineStoreSelector);

  // 入力更新処理
  const handleOnChange = (event) => {
    dispatch(fetchChangeLegendData(event.target.name, event.target.value));
  };

  return (
    <Grid container item xs={12}>
      <Grid item xs={3} className={styles.referenceLineForm}>
        <Typography variant="h6">{info.key}</Typography>
      </Grid>
      <Grid item xs={9} className={styles.referenceLineForm}>
        <TextField
          name={info.key}
          type="text"
          variant="outlined"
          className={styles.referenceLineFormInput}
          disabled={legendData.find((item) => item.type === info.key).disabled}
          value={legendData.find((item) => item.type === info.key).name}
          onChange={handleOnChange}
          error={legendData.find((item) => item.type === info.key).error}
        />
      </Grid>
    </Grid>
  );
}

PressManagementDialogFormRow.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  info: PropTypes.object.isRequired,
};

export default PressManagementDialogFormRow;
